import type { Building } from "building-types/building/buildingTypes";
import type { BuildingGenerationIssue } from "building-types/settings/buildingGenerationIssue";
import { makeWallSweeps } from "../elements/wallFacades";
import makeGenerationStageComparator from "../utils/makeGenerationStageComparator";
import memo from "../utils/memo";

function select({
  levels,
  facades,
  walls,
  roofSystems: roofs,
  settings,
  mirror,
  doc,
  enabledFeatures,
}: Pick<Building, "levels" | "facades" | "walls" | "roofSystems" | "settings" | "mirror" | "doc" | "enabledFeatures">) {
  return {
    levels,
    facades,
    walls,
    roofs,
    profileSource: {
      settingsToCatalogs: enabledFeatures.settingsToCatalogs,
      profiles: doc.profiles,
      profileSettings: settings.profile,
    },
    mirror,
  };
}

const compare = makeGenerationStageComparator<typeof select>({ profileSource: "shallow" });

function generate({ levels, facades, walls, roofs, profileSource, mirror }: ReturnType<typeof select>): {
  wallSweeps: Building["wallSweeps"];
  issues: BuildingGenerationIssue[];
} {
  const issues: BuildingGenerationIssue[] = [];
  const wallSweeps = makeWallSweeps({
    levels,
    facades,
    walls,
    roofs,
    profileSource,
    mirror,
    issues,
  });

  // wall sweeps currently flow to exterior trim and only implement exterior trim material
  return { wallSweeps, issues };
}

export default memo(select, generate, compare);
